import permission from "./permission"
import Vue  from "vue"
import store  from "../store";
//批量注册指令(现在就一个permission)
const directives = {
    permission
}
/**
 * 如果不是按钮，而是要隐藏某个页签可以使用自定义属性，通过v-if判断
 * 使用示例 <el-tab-pane  label="配置"  v-if="$has('Home')"></el-tab-pane>
 */
Vue.prototype.$permission = val => {
    let pers=store.state.permission.functionCodeList;
    let perBool=false;
      pers.some(item=>{
        if(item === val){
            perBool=true;
        }  
    });
    //最终的结果需要是boolean类型
    return perBool
  }
//注册的一般写法，循环遍历directives，通过vue.directive注册
export default {
    install(Vue){
        Object.keys(directives).forEach(key=>{
            Vue.directive(key,directives[key])
        })
    }
}



// WEBPACK FOOTER //
// ./src/directive/index.js